export default __webpack_public_path__ + "static/media/gw9.773b6ca4.webp";